let mapper_options = {
  endpoint: 'groups',
  recordClass: require('./record'),
  relations: {
    belongsTo: {
      brand: {
        foreignKey: 'brand_id',
        localField: 'brand'
      },
      division: {
        foreignKey: 'division_id',
        localField: 'division'
      }
    }
  }
}

module.exports = (store) => {
  store.defineMapper('group', mapper_options)
}
